// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import GlobalStyles from '../../../../config/styles';

const styles = ({
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    margin: '5px 0',
    width: '100%',
  },
  questionContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: GlobalStyles.color.COLOR_YELLOW_SELECT,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    color: GlobalStyles.color.COLOR_PRIMARY,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    padding: '7px 20px 5px 20px',
    cursor: 'pointer',
    '&:focus': {
      outline: 'none',
    },
  },
  openBackground: {
    backgroundColor: GlobalStyles.color.COLOR_SECONDARY,
  },
  answer: {
    borderStyle: 'solid',
    borderColor: GlobalStyles.color.COLOR_SECONDARY,
    borderWidth: 2,
    padding: 15,
    color: GlobalStyles.color.COLOR_GREY,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
  },
});

export default styles;
